import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ToastProvider } from "./contexts/ToastContext";
import LandingPage from "./pages/LandingPage";
import MatchEditor from "./pages/MatchEditor";
import MatchViewer from "./pages/MatchViewer";
import SettingsPage from "./pages/SettingsPage";
import HelpPage from "./pages/HelpPage";
import UpgradePage from "./pages/UpgradePage";
import NearbyMatchesPage from "./pages/NearbyMatchesPage";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/nearby" element={<NearbyMatchesPage />} />
            <Route
              path="/match/editor/:matchId"
              element={
                <ProtectedRoute>
                  <MatchEditor />
                </ProtectedRoute>
              }
            />
            <Route path="/match/:matchId" element={<MatchViewer />} />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <SettingsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/help"
              element={
                <ProtectedRoute>
                  <HelpPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/upgrade"
              element={
                <ProtectedRoute>
                  <UpgradePage />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Router>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
